import React, { useEffect, useMemo, useState } from "react";
import LoginComponent from "./login.component.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/reduxHooks.js";
import { loginApi, verifyTokenApi } from "../../services/auth.service.js";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import TenantNotFoundPageComponent from "../tenantNotFoundPage/tenantNotFoundPage.component.jsx";
import { Spin } from "antd";
import {
  getTenantCandidateFromHostname,
  getTenantFromHostname,
  isEkoSubdomainRequest,
} from "../../utils/tenantFromHost.js";
import { clearAuthCookies, getAuthCookieValue } from "../../utils/authCookie.js";

const LoginContainer = () => {
  const [submitting, setSubmitting] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  console.log("Vite recaptcha key: ", process.env.VITE_RECAPTCHA_SITE_KEY);
  

  const hostname = window.location.hostname;
  const tenantCandidate = getTenantCandidateFromHostname(hostname);
  const tenantFromSubdomain = getTenantFromHostname(hostname);
  const isSubdomainTenantRequest = isEkoSubdomainRequest(hostname);
  const slug = tenantFromSubdomain;
  const searchParams = new URLSearchParams(location.search);
  const nextParam = searchParams.get("next");

  const safeNextPath = useMemo(() => {
    if (!nextParam || typeof nextParam !== "string") {
      return "/dashboard";
    }

    const normalized = nextParam.trim();

    if (!normalized.startsWith("/") || normalized.startsWith("//")) {
      return "/dashboard";
    }

    if (normalized.includes("/login")) {
      return "/dashboard";
    }

    return normalized;
  }, [nextParam]);

  useEffect(() => {
    const authToken = getAuthCookieValue("authToken");

    if (!authToken) {
      setCheckingAuth(false);
      return;
    }

    dispatch(
      verifyTokenApi({
        finalCallback: () => {
          setCheckingAuth(false);
        },
        successCallback: () => {
          navigate(safeNextPath, { replace: true });
        },
        failureCallback: () => {
          clearAuthCookies();
        },
      })
    );
  }, [dispatch, navigate, safeNextPath]);

  const handleLogin = (values) => {
    console.log("values -> ", values);
    console.log("id -> ", slug);
    setSubmitting(true);
    const newObj = {
      ...values,
      client_id: slug,
      recaptcha_token: values.recaptcha_token,
    };

    dispatch(
      loginApi({
        data: newObj,
        finalCallback: () => {
          setSubmitting(false);
        },
        successCallback: (res) => {
          localStorage.removeItem("tenantSetupCompleted");
          localStorage.removeItem("tutorialComplete");
          navigate(safeNextPath, { replace: true });
        },
      })
    );
  };

  if (isSubdomainTenantRequest && !tenantFromSubdomain) {
    return <TenantNotFoundPageComponent tenantName={tenantCandidate} />;
  }

  if (checkingAuth) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.VITE_RECAPTCHA_SITE_KEY}>
      <LoginComponent
        handleLogin={handleLogin}
        submitting={submitting}
        slug={slug}
        tenantCandidate={tenantCandidate}
        isSubdomainTenantRequest={isSubdomainTenantRequest}
      />
    </GoogleReCaptchaProvider>
  );
};

export default LoginContainer;
